import { Play, ExternalLink } from "lucide-react";
import { getMoodMeta, formatDuration } from "../lib/moods";
import { coverUrl } from "../lib/api";

export default function History({ items, onOpen }) {
  if (!items || items.length === 0) {
    return (
      <div
        data-testid="history-empty"
        className="rounded-lg bg-[#181818] p-6 text-center text-[#B3B3B3]"
      >
        Aucune playlist générée pour l&apos;instant.
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4" data-testid="history-list">
      {items.map((g) => {
        const meta = getMoodMeta(g);
        return (
          <button
            key={g.id}
            onClick={() => onOpen(g)}
            data-testid={`history-item-${g.id}`}
            className="group relative text-left sp-card rounded-lg p-4 flex flex-col gap-3"
          >
            <div className="relative aspect-square rounded-md overflow-hidden shadow-[0_8px_20px_rgba(0,0,0,0.4)]">
              <img src={coverUrl(g.id, g.cover_style)} alt={meta.name} loading="lazy" className="h-full w-full object-cover" />
              <div className="absolute bottom-2 right-2 h-11 w-11 rounded-full bg-[#FF2E93] flex items-center justify-center shadow-xl translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-200">
                <Play className="h-5 w-5 text-black" fill="black" />
              </div>
            </div>
            <div className="min-w-0">
              <div className="font-extrabold text-white truncate text-sm">{meta.name || g.mood}</div>
              <div className="text-xs text-[#B3B3B3] truncate mt-0.5">
                {g.duration_minutes}min · {g.tracks?.length || 0} titres
              </div>
              <div className="text-[11px] text-[#6a6a6a] mt-0.5">{formatDuration(g.total_ms)}</div>
            </div>
            {g.saved_playlist_url && (
              <a
                href={g.saved_playlist_url}
                target="_blank"
                rel="noreferrer"
                onClick={(e) => e.stopPropagation()}
                className="absolute top-3 right-3 text-white/70 hover:text-white opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <ExternalLink className="h-4 w-4" />
              </a>
            )}
          </button>
        );
      })}
    </div>
  );
}
